module.exports = __webpack_public_path__ + "static/media/Heriot.d6b77bc5.jpg";